module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof28"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("At the same time, many officers and prominent commanders had huge debts. In 1813, General Mikhail Vorontsov owed more than 65,000 rubles to General Dokhturov and another 62,000 to General Sabaneyev. Some officers ran up enormous debts from gambling, which was part of the accepted lifestyle."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent83",
      "id": "theft83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" Upon receiving their salaries, many officers spent their nights gaming and gambling on their pledged word or making over their houses, serfs, and other possessions. Gambling was not limited to the lower ranks. In 1809, Prince Peter Bagration criticized General Mikhail Miloradovich for excessive gambling after the latter lost 35,000 rubles in Bucharest. According to Alexander Langeron, several months later, “Miloradovich gambled [another] 250,000 rubles… and was soon 600,000 rubles in debt.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent84",
      "id": "theft84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Prince Bagration was another important Russian commander in debt. Bagration’s annual income was an impressive 2,200 rubles, but his debts slowly accumulated because he had to keep up with social etiquette in the capital of the Russian Empire."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent85",
      "id": "theft85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" Bagration mortgaged his personal estates and, in early 1802, the Imperial treasurer informed Emperor Alexander that Bagration had to sell his estate back to the treasury. “[Bagration] did not determine any price on it, but informed me that he was 28,000 rubles in debt to the treasury, in addition to another 52,000 rubles in debt, for a total 80,000 rubles.” In February 1802, Alexander gave consent for the treasury to buy Bagration’s estate for 70,650 rubles. As often happens with bureaucracy though, Bagration did not receive the money for six months. On 1 July, he wrote to the state treasurer asking for an advance on the estate he sold."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent86",
      "id": "theft86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" Meanwhile, Bagration continued borrowing. In March 1804, merchant Bartholomew de Farge loaned him 3,381 rubles, which Bagration promised to repay in two months. When he could only pay back 500 rubles, the merchant sued him in court. Fortunately for Prince Peter, he was sent to fight the French in 1805 and under existing legislation, officers could not be prosecuted for debts during wartime. Returning to Russia, Bagration covered his debt to de Farge in 1806. Three years later, Bagration again approached the Imperial Treasurer to advance him two years rent from his estates."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent87",
      "id": "theft87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _vm._v(" In December 1810, Bagration sold his two houses near Constantine Palace in Pavlovsk, one of which was bought by Empress Maria Feodorovna."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent88",
      "id": "theft88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" However, debts quickly mounted when Bagration found himself unemployed in 1811. Etiquette required that Bagration frequently attend and serve dinners, which forced him to borrow even more money."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent89",
      "id": "theft89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" Fortunately, Minister of War Mikhail Barclay de Tolly helped him obtain a furlough with 9,000 rubles from the Imperial Treasury in 1811.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Besides gambling, there was also excessive indulgence in alcohol. When the Russians launched an offensive move near Smolensk in 1812, the Second Grenadier Division did not make the movement and in turn delayed other divisions stacked up behind it. Aleksey Ermolov recalled, “This division was commanded by Lieutenant General Prince Karl von Mecklenburg. Having spent the previous night feasting with friends, he was drunk, unable to command and woke up very late the next day; only then, he was able to order his troops to march.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent90",
      "id": "theft90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fdaf752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof28.vue
// module id = 177
// module chunks = 0